import { useContext } from 'react';
import { CocktailContext } from '@context';

export const useCocktailContext = () => {
  const context = useContext(CocktailContext);
  return context;
};
